import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import _get from 'lodash/get'
import { connect as connectStaticText } from '../../StaticText/connect'
import { H1, H2, HEADING_TYPES } from '../../Heading/index'
import Button, { TYPES } from '../../Button/index'
import Link from '../../Link/index'
import GaiaLogo, { TYPE_WHITE } from '../../GaiaLogo/index'
import {
  URL_LOGOUT,
  URL_PLAN_SELECTION_PLANS,
  URL_MARKETPLACE_LOGGED_IN,
  URL_PLAYLIST_PURCHASES_VIDEOS,
} from '../../../services/url/constants'
import { getPrimary } from '../../../services/languages/index'
import { EN } from '../../../services/languages/constants'
import { getUserName } from '../../../services/user/index'
import { get as getConfig } from '../../../config/index'
import { hasPurchaseOnlyEntitlement } from '../../../services/subscription/index'

const config = getConfig()
const purchaseOnlyUserFlowActive = !!_get(config, ['features', 'purchaseOnlyUserFlow'])

const ModalCartAbandonV2 = ({
  user,
  auth,
  staticText,
}) => {
  const userLanguage = getPrimary(user.getIn(['data', 'language']))
  const userName = getUserName(user.get('data'))
  const purchasesUrl = purchaseOnlyUserFlowActive
    ? URL_PLAYLIST_PURCHASES_VIDEOS
    : `${URL_MARKETPLACE_LOGGED_IN}?redirect=my-stuff`
  const isPurchaseOnlyUser = purchaseOnlyUserFlowActive && hasPurchaseOnlyEntitlement(auth.get('subscriptions'))

  return (
    <div className="modal-cart-abandon-v2">
      <div className="modal-cart-abandon-v2__wrapper">
        <header className="modal-cart-abandon-v2__header">
          <GaiaLogo
            type={TYPE_WHITE}
            className={['modal-cart-abandon-v2__gaia-logo']}
            isHref={false}
          />
          <Link
            className="modal-cart-abandon-v2__sign-out"
            to={URL_LOGOUT}
            scrollToTop
          >
            {staticText.getIn(['data', 'signOut'])}
          </Link>
        </header>
        <div className="modal-cart-abandon-v2__content-wrapper">
          <div className="modal-cart-abandon-v2__content">
            <H1
              as={HEADING_TYPES.H6}
              className="modal-cart-abandon-v2__title"
              inverted
            >
              {`${staticText.getIn(['data', 'welcomeBack'])}, ${userName}!`}
            </H1>
            <H2
              as={HEADING_TYPES.H4}
              className="modal-cart-abandon-v2__subtitle"
              inverted
            >
              {staticText.getIn(['data', 'watchAccessDescription'])}
            </H2>
            <Button
              className="modal-cart-abandon-v2__button"
              type={TYPES.PRIMARY}
              url={URL_PLAN_SELECTION_PLANS}
              scrollToTop
            >
              {staticText.getIn(['data', 'startFreeTrial'])}
            </Button>
            <p className="modal-cart-abandon-v2__disclaimer">
              {staticText.getIn(['data', 'availableForSelectedPlans'])}
            </p>
          </div>
          {userLanguage === EN
            ? <div className="modal-cart-abandon-v2__content">
              <H2
                as={HEADING_TYPES.H5}
                className="modal-cart-abandon-v2__title-marketplace"
                inverted
              >
                {staticText.getIn(['data', 'contentFromMarketPlace'])}
              </H2>
              <div className="modal-cart-abandon-v2__buttons-wrapper">
                <Button
                  className="modal-cart-abandon-v2__button"
                  type={TYPES.SECONDARY}
                  url={purchasesUrl}
                  scrollToTop
                  inverted
                  directLink
                >
                  {staticText.getIn(['data', 'viewPurchasedContent'])}
                </Button>
                {isPurchaseOnlyUser
                  && <Button
                    className="modal-cart-abandon-v2__button"
                    type={TYPES.SECONDARY}
                    url={`${URL_MARKETPLACE_LOGGED_IN}?redirect=my-stuff`}
                    scrollToTop
                    inverted
                    directLink
                  >
                    {staticText.getIn(['data', 'goToMarketplace'])}
                  </Button>
                }
              </div>
            </div>
            : null}
        </div>
      </div>
    </div>
  )
}

ModalCartAbandonV2.propTypes = {
  staticText: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
}

export default compose(
  connectStaticText({ storeKey: 'modalCartAbandonV2' }),
  connectRedux(
    (state) => ({
      user: state.user,
      auth: state.auth,
    }),
  ),
)(ModalCartAbandonV2)
